/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class ResourceValidationError {
  /**
  * The configuration field that failed validation
  */
  'field': string;
  /**
  * Human-readable error message describing what is wrong
  */
  'message': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "field",
      "baseName": "field",
      "type": "string",
      "format": ""
    },
    {
      "name": "message",
      "baseName": "message",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ResourceValidationError.attributeTypeMap;
  }

  public constructor() {
  }
}

